/**
 * Utility per la paginazione dei dati
 */
export const calcolaPaginazione = <T>(
  dati: T[],
  paginaCorrente: number,
  elementiPerPagina: number
) => {
  const indiceInizio = (paginaCorrente - 1) * elementiPerPagina;
  const indiceFine = indiceInizio + elementiPerPagina;
  const elementiPaginati = dati.slice(indiceInizio, indiceFine);
  const totalePagine = Math.ceil(dati.length / elementiPerPagina);

  return {
    elementiPaginati,
    totalePagine,
    indiceInizio,
    indiceFine,
  };
};

/**
 * Tronca il testo se supera la lunghezza massima
 */
export const troncaTesto = (testo: string, lunghezzaMax: number): string => {
  if (testo.length <= lunghezzaMax) {
    return testo;
  }
  return `${testo.substring(0, lunghezzaMax)}...`;
};

/**
 * Formatta un numero con decimali
 */
export const formattaNumeroDecimale = (numero: number, decimali: number = 2): string => {
  return numero.toFixed(decimali);
};

/**
 * Ottiene la data di inizio del mese corrente in formato YYYY-MM-DD
 */
export const getInizioMeseCorrente = (): string => {
  return new Date(new Date().setDate(1)).toISOString().split('T')[0];
};

/**
 * Ottiene la data corrente in formato YYYY-MM-DD
 */
export const getDataCorrente = (): string => {
  return new Date().toISOString().split('T')[0];
};
